import { render, staticRenderFns } from "./OidcSignout.vue?vue&type=template&id=427815bc&scoped=true&"
import script from "./OidcSignout.vue?vue&type=script&lang=js&"
export * from "./OidcSignout.vue?vue&type=script&lang=js&"
import style0 from "./OidcSignout.vue?vue&type=style&index=0&id=427815bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427815bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/projets/dotnet/GestionTournees/dev/GestionTourneesWeb/ClientApp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
